import { IconInfoCircle, IconShop, IconTruckTime } from '@/features/icons';
import Tooltip from '@/features/tooltip';
import { cn } from '@/utils/cn';
import { useVariantContextValues } from '../../context/use-variant-context-values';
function VendorDetailsMobile() {
  const {
    vendorDetails,
    noVendorDetails
  } = useVariantContextValues('pdp');
  const {
    tooltipText,
    leadTimeText,
    vendorText
  } = vendorDetails || {};
  return <div className={cn('pdp-container transition-all duration-300', {
    'mt-3 opacity-100': !noVendorDetails,
    'h-16': !noVendorDetails && leadTimeText && vendorText,
    'h-9': !noVendorDetails && (vendorText && !leadTimeText || !vendorText && leadTimeText),
    'h-0 opacity-0': noVendorDetails
  })} data-sentry-component="VendorDetailsMobile" data-sentry-source-file="mobile.tsx">
            {!noVendorDetails && <div className='relative flex items-center justify-between rounded border border-border-gray-light bg-surface-solid-0 p-2 text-caption-12 text-text-mediumGray'>
                    <div className='flex flex-col gap-2'>
                        {!!vendorText && <div className='relative flex items-center gap-1.5'>
                                <IconShop className='h-5 w-5' />
                                <span>{vendorText}</span>
                            </div>}

                        {!!leadTimeText && <div className='flex items-center gap-1.5'>
                                <IconTruckTime className='h-5 w-5' />
                                <span>{leadTimeText}</span>
                            </div>}
                    </div>

                    {!!tooltipText && <Tooltip className='w-full' position='top' tooltipText={tooltipText}>
                            <IconInfoCircle className='h-5 w-5 text-alert-info-dark' />
                        </Tooltip>}
                </div>}
        </div>;
}
export default VendorDetailsMobile;